import React, { useEffect, useState, memo } from 'react';
import { AiOutlineRocket } from 'react-icons/ai';
import { FiArrowLeft } from 'react-icons/fi';
import Lottie from 'react-lottie';
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, FormGroup, H6, InputGroup, MenuItem } from '@blueprintjs/core';
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import { Select } from "@blueprintjs/select";

import { LogomarcaGAVResortsOriginal as LogomarcaGAVResorts, LogomarcaHarmoniaUrbanismoOriginal as LogomarcaHarmoniaUrbanismo, LogomarcaSilvaBrancoOriginal as LogomarcaSilvaBranco, LogomarcaDigitalDevOriginal as LogomarcaDigitalDev } from '../../Assets';
import { SignIn as ContextSignIn } from '../../Context';
import * as LottieFiles from '../../Data/Lottie';
import { Logon } from '../../Services/Controllers';
import { NotificacaoInterna } from '../../Services/Notification';
import { CPF } from '../../Themes/TextFormat';

import { Container, Background, Form, Footer } from './style';
import viewModel from './viewModel';
import { Objeto } from "../../Services/Models";

const View: React.FC<viewModel> = (viewModel) => {
    /* #region  Variáveis  */
    const [getAlterandoSenha, setAlterandoSenha] = useState(false);
    const [getFormularioSenha, setFormularioSenha] = useState<string>("");
    const [getFormularioSenhaConfirmada, setFormularioSenhaConfirmada] = useState<string>("");
    const [getItemPickerGrupoDeEmpresas, setItemPickerGrupoDeEmpresas] = useState<{ grupo: string, empresas: Array<Objeto.Empresa> }>();
    const PickerGrupoDeEmpresas = Select.ofType<{ grupo: string, empresas: Array<Objeto.Empresa> }>();
    const History = useHistory();
    const Token = (useParams() as any).Token;
    /* #endregion */

    /* #region  Funções  */
    /* Sobre esta função *//**
     * Valida os dados digitados e tenta efetuar o login do usuário
     **/
    async function EfetuarAlteracaoDeSenha(): Promise<void> {
        await setAlterandoSenha(true);
        if (await ValidarFormulario() == true) {
            var Response = await Logon.Put(Token, getFormularioSenha, getFormularioSenhaConfirmada);
            if (Math.floor(Response.status / 100) == 2) {
                History.replace("/");
                window.location.reload();
                await ContextSignIn.setContext(Response.data)

                console.log(Response.data);
                NotificacaoInterna.ExibirNotificacao("Caro usuário", "Sua senha foi devidamente alterada! Realize novamente o seu login!", NotificacaoInterna.TipoDeNotificacao.Sucesso);
            }
            else {
                console.log(Response)
                NotificacaoInterna.ExibirNotificacao("Caro usuário", "Houve um erro ao tentar alterar a sua senha em nosso sistema, por favor, tente novamente mais tarde!", NotificacaoInterna.TipoDeNotificacao.Erro);
            }
        }
        await setAlterandoSenha(false);
    };
    async function ValidarFormulario(): Promise<Boolean> {
        if (!getFormularioSenha) {
            NotificacaoInterna.ExibirNotificacao("Senha não preenchida", "Informe a senha", NotificacaoInterna.TipoDeNotificacao.Erro);
            return false;
        }
        if (!getFormularioSenhaConfirmada) {
            NotificacaoInterna.ExibirNotificacao("Senha não confirmada", "Confirme a sua senha", NotificacaoInterna.TipoDeNotificacao.Erro);
            return false;
        }
        return true
    }
    useEffect(() => {
        async function componentDidMount() {

        }
        componentDidMount();
    }, []);
    return (
        <Container>
            <Background />
            <Card elevation={2}>
                <Form>
                    <img style={{ marginBottom: "20px" }} src={getItemPickerGrupoDeEmpresas?.grupo == "GAV Resorts" ? LogomarcaGAVResorts :
                        (getItemPickerGrupoDeEmpresas?.grupo == "Harmonia Urbanismo" ? LogomarcaHarmoniaUrbanismo :
                            (getItemPickerGrupoDeEmpresas?.grupo == "Silva Branco" ? LogomarcaSilvaBranco : LogomarcaDigitalDev))} />
                    <H6>Preencha os campos abaixo</H6>
                    <FormGroup label="Nova senha:" inline={true} >
                        <InputGroup id="enha" placeholder="*****************" value={getFormularioSenha} type="password" style={{ width: "206px" }}
                            onChange={async (event: React.FormEvent<HTMLInputElement>) => await setFormularioSenha(event.currentTarget.value)}>
                        </InputGroup>
                    </FormGroup>
                    <FormGroup label="Comfirme a senha:" inline={true} >
                        <InputGroup id="SenhaConfirmada" placeholder="*********" value={getFormularioSenhaConfirmada} type="password" style={{ width: "162px" }}
                            onChange={async (event: React.FormEvent<HTMLInputElement>) => await setFormularioSenhaConfirmada(event.currentTarget.value)}>
                        </InputGroup>
                    </FormGroup>
                    <div>
                        {getAlterandoSenha == true && <div style={{ marginLeft: "40px", width: 100, height: 100 }}>
                            <Lottie options={{ animationData: LottieFiles.Load, loop: true, autoplay: true, rendererSettings: { preserveAspectRatio: 'xMidYMid slice' } }} />
                        </div>}
                        {getAlterandoSenha == false && <div style={{ height: 100 }}>
                            <Button type="submit" intent="primary" onClick={EfetuarAlteracaoDeSenha} style={{ width: "220px", height: "30px" }}>Confirmar</Button>
                        </div>}
                        <a href="/"><FiArrowLeft />Voltar para tela de Login</a>
                    </div>
                    <Footer>
                        <a>
                            <AiOutlineRocket size={20} />Desenvolvido por &nbsp;<img src={LogomarcaDigitalDev} height={30} alt="DigitalDev" />
                        </a>
                    </Footer>
                </Form>
            </Card>
        </Container>
    );
    /* #endregion */
};

export default View;